import { AuthService } from './auth/auth.service';
import { AmplifyHttpClient } from './auth/http.amplify-httpclient';
import { ChatroomService } from './chatroom/chatroom.service';
import { ChecklistUpdate } from './checklist-update/checklist-update.service';
import { ChecklistService } from './checklist/checklist.service';
import { ClosedSideNavTemplate } from './closed-side-nav-template/closed-side-nav-template.service';
import { ColoborationManagementAdmin } from './coloboration-management-admin/coloboration-management-admin.service';
import { CommonService } from './common/common.service';
import { DataExtractionService } from './data-extraction/data-extraction.service';
import { FileDataObjectTransferService } from './file-data-object-transfer/file-data-object-transfer.service';
import { FolderFileUpdateCommonFileUploadService } from './folder-file-update-common-file-upload/folder-file-update-common-file-upload.service';
import { GraphQLService } from './graphql/graphql.service';
import { HelpCenterService } from './help-center/help-center.service';
import { LoaderService } from './loader/loader.service';
import { LocationService } from './location/location.service';
import { MessengerService } from './messenger/messenger.service';
import { ModalService } from './Modal/modal.service';
import { MoveToNetworkService } from './move-to-network/move-to-network.service';
import { MovedToNewVaultService } from './moved-to-new-vault/moved-to-new-vault.service';
import { MovedToSharedVault } from './moved-to-shared-vault/moved-to-shared-vault.service';
import { MyInformationUploadFile } from './my-information-upload-file/my-information-upload-file.service';
import { MyWorkspaceUploadFile } from './my-workspace-upload-file/my-workspace-upload-file.service';
import { NotesService } from './notes/notes.service';
import { NotificationService } from './notification/notification.service';
import { NotifyAPIUpdateService } from './notify-api-update/notify-api-update.service';
import { NotifyAssociationDocumentUpdateService } from './notify-association-document-update/notifyAssociationDocumentUpdate.service';
import { NotifyDocumentCreatedAddAsLocation } from './notify-document-created-add-as-location/notifyDocumentCreatedAddAsLocation.service';
import { NotifyDocumentCreatedAddAsRolePlayers } from './notify-document-created-add-as-roleplayers/notify-document-created-add-as-roleplayers';
import { NotifyFormSetupSidebar } from './notify-form-setup-sidebar/notify-form-setup-sidebar.service';
import { NotifyLinkedItemsUpdateService } from './notify-linked-items-update/notify-linked-items-update.service';
import { NotifyLinkedSetupSidebar } from './notify-linked-setup-sidebar/notify-linked-setup-sidebar.service';
import { NotifyMoveToSharedVaultService } from './notify-move-to-shared-vault/notify-move-to-shared-vault.service';
import { NotifyReportUpdateService } from './notify-report-update/notify-report-update.service';
import { NotifyRolePlayersUpdateService } from './notify-role-players-update.service/notify-role-players-update.service';
import { NotifySharingUpdateService } from './notify-sharing-update/notify-sharing-update.service';
import { NotifySummaryUpdateService } from './notify-summary-update/notify-summary-update.service';
import { NotifyUpdateReportDollarPercentage } from './notify-update-report-dollar-percentage/notify-update-report-dollar-percentage.service';
import { NotifyUserMoveToInsideVaultUpdate } from './notify-user-move-to-inside-vault/notify-user-move-to-inside-vault-update.service';
import { OpenKeyEncryptionSidebarService } from './OpenKeyEncryptionSidebarService/open-key-encryption-sidebar.service';
import { OpenManageTagsSidebarService } from './open-manage-tags-sidebar/open-manage-tags-sidebar.service';
import { PostService } from './post/post.service';
import { ReminderUpdate } from './reminder-update/reminder-update.service';
import { ScriptService } from './script/script.service';
import { SearchService } from './search/search.service';
import { ShowSideBarReportService } from './show-side-bar-report/show-side-bar-report.service';
import { MxTaskbarService } from './mx-taskbar/mx-taskbar.service';
import { TreeStructureService } from './tree-structure.service';
import { UrlService } from './url-service/url.service';
import { UserPermissionService } from './user-permission/user-permission.service';
import { UserService } from './user/user.service';
import { UserConnectionService } from './user_connection/user-connection.service';
import { VaultAuthGuardService } from './vault-auth-guard/vault-auth-guard.service';
import { DocumentService } from './vault/document.service';
import { NotifyOpenFormSidebarVault } from './notify-open-form-sidebar-vault/notify-move-to-shared-vault.service';
import { NotifyIncompleteFormsForReports } from './notify-incomplete-forms-for-reports/notifyIncompleteFormsForReports.service';
import { NotifyUpdateItemToResolve } from './notify-update-item-to-resolve/notify-update-item-to-resolve.service';
import { NotifyOpenInbox } from './notify-open-inbox/notify-open-inbox.service';
import { NotifyWorkspaceOpen } from './notify-workspace-open/notify-workspace-open.service';
import { DataExtractionToggle } from './data-extraction-toggle/data-extraction-toggle.service';
import { DialogEventService } from './dialog/dialog-refresh-service.component';
import { NotifyNetworkUpdate } from './notify-network-update/notify-network-update.service';
import { NotifyDocumentWhenLinkedPositionCreated } from './notify-document-when-linked-position-created/notify-document-when-linked-position-created';
import { NotifyOpenTemplateRegister } from './notify-open-template-register/notify-open-template-register.service';
import { NotifyInboxSuggestionUpdate } from './notify-inbox-suggestion-update/notify-inbox-suggestion-update.service';
import { GlobalSearchService } from './global-search/global-search.service';
import { NotifyOpenDirectDelivery } from './notify-open-direct-delivery/notify-open-direct-delivery.service';

export { NotifyReportUpdateService } from './notify-report-update/notify-report-update.service';
export { NotifyMoveToSharedVaultService } from './notify-move-to-shared-vault/notify-move-to-shared-vault.service';
export { ClosedSideNavTemplate } from './closed-side-nav-template/closed-side-nav-template.service';
export { NotifyUserMoveToInsideVaultUpdate } from './notify-user-move-to-inside-vault/notify-user-move-to-inside-vault-update.service';
export { AuthService } from '@app/shared/services/auth/auth.service';
export { CommonService } from '@app/shared/services/common/common.service';
export { SearchService } from '@app/shared/services/search/search.service';
export { UrlService } from '@app/shared/services/url-service/url.service';
export { UserService } from '@app/shared/services/user/user.service';
export { UserConnectionService } from '@app/shared/services/user_connection/user-connection.service';
export { VaultAuthGuardService } from '@app/shared/services/vault-auth-guard/vault-auth-guard.service';
export { ChatroomService } from './chatroom/chatroom.service';
export { HelpCenterService } from './help-center/help-center.service';
export { LoaderService } from './loader/loader.service';
export { MessengerService } from './messenger/messenger.service';
export { NotificationService } from './notification/notification.service';
export { PostService } from './post/post.service';
export { UserPermissionService } from './user-permission/user-permission.service';
export { DocumentService } from './vault/document.service';
export { FolderFileUpdateCommonFileUploadService } from './folder-file-update-common-file-upload/folder-file-update-common-file-upload.service';
export { TreeStructureService } from './tree-structure.service';
export { MyInformationUploadFile } from './my-information-upload-file/my-information-upload-file.service';
export { MyWorkspaceUploadFile } from './my-workspace-upload-file/my-workspace-upload-file.service';
export { ColoborationManagementAdmin } from './coloboration-management-admin/coloboration-management-admin.service';
export { NotifyLinkedItemsUpdateService } from './notify-linked-items-update/notify-linked-items-update.service';
export { ChecklistUpdate } from './checklist-update/checklist-update.service';
export { NotifySummaryUpdateService } from './notify-summary-update/notify-summary-update.service';
export { ReminderUpdate } from './reminder-update/reminder-update.service';
export { NotifyAssociationDocumentUpdateService } from './notify-association-document-update/notifyAssociationDocumentUpdate.service';
export { MoveToNetworkService } from './move-to-network/move-to-network.service';
export { ShowSideBarReportService } from './show-side-bar-report/show-side-bar-report.service';
export { MovedToSharedVault } from './moved-to-shared-vault/moved-to-shared-vault.service';
export { NotifyDocumentCreatedAddAsLocation } from './notify-document-created-add-as-location/notifyDocumentCreatedAddAsLocation.service';
export { NotifyUpdateReportDollarPercentage } from './notify-update-report-dollar-percentage/notify-update-report-dollar-percentage.service';
export { DataExtractionService } from './data-extraction/data-extraction.service';
export { MovedToNewVaultService } from './moved-to-new-vault/moved-to-new-vault.service';
export { NotifyFormSetupSidebar } from './notify-form-setup-sidebar/notify-form-setup-sidebar.service';
export { NotifyLinkedSetupSidebar } from './notify-linked-setup-sidebar/notify-linked-setup-sidebar.service';
export { OpenKeyEncryptionSidebarService } from './OpenKeyEncryptionSidebarService/open-key-encryption-sidebar.service';
export { NotifyOpenFormSidebarVault } from './notify-open-form-sidebar-vault/notify-move-to-shared-vault.service';
export { NotifyIncompleteFormsForReports } from './notify-incomplete-forms-for-reports/notifyIncompleteFormsForReports.service';
export { NotifyUpdateItemToResolve } from './notify-update-item-to-resolve/notify-update-item-to-resolve.service';
export { NotifyOpenInbox } from './notify-open-inbox/notify-open-inbox.service';
export { NotifyWorkspaceOpen } from './notify-workspace-open/notify-workspace-open.service';
export { DataExtractionToggle } from './data-extraction-toggle/data-extraction-toggle.service';
export { DialogEventService } from './dialog/dialog-refresh-service.component';
export { NotifyNetworkUpdate } from './notify-network-update/notify-network-update.service';
export { NotifyOpenTemplateRegister } from './notify-open-template-register/notify-open-template-register.service';
export { NotifyInboxSuggestionUpdate } from './notify-inbox-suggestion-update/notify-inbox-suggestion-update.service';
export { NotifyOpenDirectDelivery } from './notify-open-direct-delivery/notify-open-direct-delivery.service';
export { Services };

const Services = [
  AuthService,
  UserService,
  UrlService,
  NotifyLinkedSetupSidebar,
  OpenKeyEncryptionSidebarService,
  OpenManageTagsSidebarService,
  NotifyOpenFormSidebarVault,
  CommonService,
  NotifyIncompleteFormsForReports,
  SearchService,
  ModalService,
  FileDataObjectTransferService,
  UserConnectionService,
  NotifyDocumentCreatedAddAsLocation,
  PostService,
  NotificationService,
  NotifyWorkspaceOpen,
  MessengerService,
  HelpCenterService,
  DataExtractionToggle,
  NotifyAssociationDocumentUpdateService,
  DocumentService,
  ChatroomService,
  ClosedSideNavTemplate,
  FolderFileUpdateCommonFileUploadService,
  LoaderService,
  UserPermissionService,
  AmplifyHttpClient,
  MyInformationUploadFile,
  MyWorkspaceUploadFile,
  ShowSideBarReportService,
  ColoborationManagementAdmin,
  NotifyLinkedItemsUpdateService,
  TreeStructureService,
  NotifySummaryUpdateService,
  NotifyUpdateItemToResolve,
  ScriptService,
  GraphQLService,
  NotifyOpenInbox,
  NotifyUserMoveToInsideVaultUpdate,
  LocationService,
  VaultAuthGuardService,
  NotifyMoveToSharedVaultService,
  ChecklistService,
  ChecklistUpdate,
  MovedToSharedVault,
  ReminderUpdate,
  NotifyReportUpdateService,
  MoveToNetworkService,
  DataExtractionService,
  NotesService,
  MxTaskbarService,
  MovedToNewVaultService,
  NotifyRolePlayersUpdateService,
  NotifyAPIUpdateService,
  NotifyFormSetupSidebar,
  NotifySharingUpdateService,
  NotifyDocumentCreatedAddAsRolePlayers,
  NotifyDocumentWhenLinkedPositionCreated,
  DialogEventService,
  NotifyOpenTemplateRegister,
  NotifyNetworkUpdate,
  NotifyOpenDirectDelivery,
  NotifyInboxSuggestionUpdate,
  GlobalSearchService,
];
